import { computed, ref } from 'vue';

export type Theme = 'light' | 'dark';

const THEME_KEY = 'theme';

/**
 * Текущая тема сайта (light / dark).
 *
 * Инициализация не нужна: каждый HTML-файл ещё до загрузки приложения
 * выставляет атрибут data-theme по localStorage или системным настройкам.
 * Здесь значение считывается из уже применённого атрибута, поэтому
 * переключение происходит только по кнопке.
 */
const theme = ref<Theme>(readTheme());

/** Реактивный флаг: активна ли тёмная тема. */
export const isDark = computed(() => theme.value === 'dark');

function readTheme(): Theme {
  const applied = document.documentElement.getAttribute('data-theme');
  if (applied === 'light' || applied === 'dark') return applied;

  // Страховка: если атрибут не выставлен — читаем localStorage напрямую
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return 'light';
}

/** Применяет тему к корневому элементу документа и сохраняет выбор в localStorage. */
function apply(next: Theme) {
  theme.value = next;
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem(THEME_KEY, next);
}

/** Переключение между светлой и тёмной темой (вызывается по нажатию кнопки). */
export function toggleTheme() {
  apply(theme.value === 'dark' ? 'light' : 'dark');
}
